import { render, staticRenderFns } from "./ConfigDefaultModel.vue?vue&type=template&id=cf680b2e&scoped=true"
import script from "./ConfigDefaultModel.vue?vue&type=script&lang=js"
export * from "./ConfigDefaultModel.vue?vue&type=script&lang=js"
import style0 from "./ConfigDefaultModel.vue?vue&type=style&index=0&id=cf680b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf680b2e",
  null
  
)

export default component.exports